import HomeIcon from "./HomeIcon";
import Vendoricon from "./Vendoricon";
import SettingsIcon from "./SettingsIcon";
import OptionIcon from "./OptionIcon";
import HelpIcon from "./HelpIcon"
import questionnaire from "./questionnaire";
import Finacial from "./Financial";
import Reports from "./Reports";
import ReportIcon from "./ReoprtIcon";
import TrainingIcon from "./TrainingIcons";
import OnsiteIcon from "./OnsiteIcon";
import PrequlIcon from "./PrequlIcon";
const Icons = {
  'Home': HomeIcon,
  'Users': Vendoricon,
  'Settings': SettingsIcon,
  'Options': OptionIcon,
  "HelpIcon":HelpIcon,
  "questionnaire":questionnaire, 
  "Finacial":Finacial,
  "Reports":ReportIcon,
  "Training":TrainingIcon,
  "Onsite":OnsiteIcon,
  "Preq":PrequlIcon
};

export default Icons;